import { NextPage } from 'next';
import React from 'react';
import FdrBookmarkPageContent from 'components/domain/fdr-bookmark/fdr-bookmark-page-content';

export { getServerSideProps } from 'components/page/bookmark/bookmark.gssp';

const BookmarkPage: NextPage = () => {
  return <FdrBookmarkPageContent />;
};

export default BookmarkPage;
